<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-breadcrumbs :items="items" :divider="'|'" class="py-0">
            <template v-slot:item="props">
              <v-breadcrumbs-item
                :href="props.item.href"
                :class="[props.item.disabled && 'disabled']"
                style="font-size: 12px;"
              ><span style="color: black;" v-bind:class="{bold: props.item.text == 'Pedido Procesado'}">{{ props.item.text }}</span></v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row class="my-10">
        <v-col cols="12" class="text-center">
          <span class="PTSerif bold" style="font-size: 20px;">Tu pedido ha sido procesado</span>
        </v-col>
      </v-row>

      <v-row class="d-flex d-md-none">
        <v-col offset="1">
          <span class="d-block">
            <span class="bold">NÚM. DE ORDEN</span>
            <span class="ml-5">00000000</span>
          </span>
          <span class="d-block">
            <span class="bold">FECHA</span>
            <span class="ml-5" v-if="datos_envio">{{ currentDate }}</span>
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="Roboto">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-center bold d-none d-md-table-cell"
                    style="font-size: 12px; color:#000"
                  >NÚM. DE ORDEN</th>
                  <th class="text-center bold" style="font-size: 12px; color:#000">PRODUCTO</th>
                  <th class="text-center bold" style="font-size: 12px; color:#000">CANTIDAD</th>
                  <th class="text-center bold" style="font-size: 12px; color:#000">PRECIO</th>
                  <th
                    class="text-center bold d-none d-md-table-cell"
                    style="font-size: 12px; color:#000"
                  >FECHA</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in cart" :key="i" class="text-center">
                  <td style="color:#000;" class="d-none d-md-table-cell">00000000</td>
                  <td style="color:#000;">{{item.producto.name}}</td>
                  <td style="color:#000;">{{item.cantidad}}</td>
                  <td style="color:#000;">${{item.producto.precio * item.cantidad}}.00 MX</td>
                  <td class="d-none d-md-table-cell">{{ currentDate }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>

      <v-row class="my-10">
        <v-col></v-col>
        <v-col class="d-flex justify-space-around Roboto">
          <div>
            <span class="d-block bold" style="font-size: 16px">TOTAL</span>
          </div>
          <div class="text-right">
            <span class="d-block" style="font-size: 16px">${{ sumarTotal }}.00 MX</span>
            <span class="d-block" style="font-size: 10px; color: #979797;">IVA INCLUIDO</span>
            <span class="d-block" style="font-size: 10px; color: #979797;">COSTO DE ENVÍO INCLUIDO</span>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="py-0">
      <v-row>
        <v-col class="px-0 py-0">
          <router-link to="/" style="text-decoration: none;">
            <v-btn block color="#B4613D" dark tile>VOLVER A LA TIENDA</v-btn>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import VueSession from "vue-session";
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
Vue.use(VueSession, {
  persist: true
});

Vue.use(VueMoment, {
  moment
});

export default {
  data() {
    return {
      cart: [],
      datos_envio: [],
      currentDate: moment().locale('es').format('L'),
      items: [
        {
          text: "Inicio",
          disabled: false,
          href: 'home'
        },
        {
          text: "Carrito de Compra",
          disabled: true
        },
        {
          text: "Datos de Envío",
          disabled: true
        },
        {
          text: "Tipo de Pago",
          disabled: false
        },
        {
          text: "Pedido Procesado",
          disabled: true
        }
      ]
    };
  },
  created() {
    this.cart = this.$session.get("cart");
    this.datos_envio = this.$session.get("datos_envio");
  },
  methods: {},
  computed: {
    sumarTotal() {
      var total = 0;
      for (var i = 0; i < this.cart.length; i++) {
        total += this.cart[i].cantidad * this.cart[i].producto.precio;
      }

      return total;
    },
  }
};
</script>